
import moment from "moment";
import PageDetailHeader from '@/components/core/PageDetailHeader';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import loaderComponent from '@/components/loaderComponent'
import EventCardGeneral from '@/components/EventCardGeneral.vue';
import googleAd from '@/components/gAdUnitCode'
import Share from '@/components/Share'
export default {
  layout: 'details-page',
  components: {
    PageDetailHeader,
    VueSlickCarousel,
    loaderComponent,
    EventCardGeneral,
    googleAd,
    Share
  },
  head() {
    return {
      title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.metaDesc()
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: this.metaKeywords()
      },
      {
        hid: 'image',
        property: 'image',
        content: this.metaImage()
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.metaImage()
      },
      {
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: this.metaImage()
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.metaDesc()
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.metaDesc()
      }
      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      activitySlug: null,
      listings: null,
      relatedListings: null,
      loading: true,
      listingLoading: true,
      seoData: null,
      rating: 5,
    }
  },
  jsonld() {
    if (!this.listings) {
      return null;
    }
    return {
      '@context': 'https://schema.org',
      "@type": "Article",
      "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/caption/" + this.activitySlug
      },
      "headline": this.seoData && this.seoData.title ? this.seoData.title : 'Instagram Captions - Goa App',
      "name": this.seoData && this.seoData.title ? this.seoData.title : 'Instagram Captions - Goa App',
      "url": "https://goa.app/caption/" + this.activitySlug,
      "description": this.metaDesc(),
      "image": this.listings && this.listings && this.listings.gallery ? this.listings.gallery : 'https://goa.app/img/service-imgs/Instagram-caption.webp',
      "author": {
        "@type": "Person",
        "name": "Sanjeet Kamat"
      },
      "publisher": {
        "@type": "Organization",
        "name": "Goa App",
        "logo": {
          "@type": "ImageObject",
          "url": "https://goa.app/goa-app-logo.svg"
        }
        },
      "genre": this.listings && this.listings.categories ? this.listings.categories : 'Instagram Captions',
      "keywords": this.listings && this.listings.text ? this.listings.text : '', 
      "datePublished": "2024-09-08",
      "dateCreated": "2024-09-08",
      "dateModified": "2024-09-08",
      "description": this.listings && this.listings.seoDescription ? this.listings.seoDescription : '',
      "articleBody": this.listings && this.listings.text ? this.listings.text : '',
    };
  },
  async validate({
    params,
    store
  }) {
    // await operations
    if (params.slug != (null || "")) {
      this.activitySlug = params.slug;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.activitySlug = this.$route.params.slug;
    this.$fetch();
  },
  mounted() {
    this.getAllData();
  },
  destroyed() {
  },
  async fetch() {
          this.seoData = await fetch(this.$config.fetchUrl + '/api/caption/seo/getSEOContent/' + this.activitySlug)
            .then(res => res.json()).catch(error => {
              //this.$router.push({
      //          path: '/'
      //        })
              console.error("There was an error!", error); return false;
            });
  },
  methods: {
    async getAllData() {
      //Get the list of post data
      this.listings = await fetch(this.$config.fetchUrl + '/api/caption/' + this.activitySlug)
        .then(res => res.text()).catch(error => {
          this.$router.push({
            path: '/'
          })
          console.error("There was an error!", error); return false;
        });
      let items = this.getCryptKey(this.listings);
      if (items)
        this.listings = items;
      this.$nextTick(() => {
        this.loading = false;
      })
    },
    metaDesc() {
      if (this.seoData && this.seoData.description) {
        return this.seoData.description
      } else {
        return ''
      }
    },
    metaKeywords() {
      if (this.seoData && this.seoData.keywords) {
        return this.seoData.keywords;
      } else {
        return ''
      }
    },
    metaImage() {
      if (this.seoData && this.seoData.image) {
        return this.seoData.image;
      } else {
        return 'https://goa.app/img/service-imgs/Instagram-caption.webp'
      }
    },
    syncSliders(currentPosition, nextPosition) {
      this.$refs['slick1'].goTo(nextPosition)
      this.$refs['slick2'].goTo(nextPosition)
    },
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`)
    },
    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();
      // remove accents, swap ñ for n, etc
      var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }
      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes
      return str;
    },
    goTotags(tag) {
      let tagSlug = this.string_to_slug(tag)
      this.$router.push({
        path: "/tags/" + tagSlug
      });
    },
    async copycaption(caption){
    try {
      await navigator.clipboard.writeText(caption);
      this.$bvToast.toast('Copied', {
          toaster: 'b-toaster-bottom-center',
          solid: true,
          autoHideDelay: 1000,
          noCloseButton:true
        })
    } catch($e) {
      console.log($e);
    }
      }
  }
}
